import { useEffect, useState } from 'react';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const useDebounce = <T>(value: T, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [delay, value]);

  return debouncedValue;
};

export default useDebounce;
